export default "dist/images/components-design-separator-control-wave-4.b82e3aa.png";